export default {
  label: {
    aggregationText: 'Total de ',
    aggregationTextAvgSAC: 'Tiempo Promedio de Captura',
    notShowClassifiedLabel: 'Mostrar no clasificados',
    showClassifiedLabel: 'Ocultar no clasificados',
    filter: {
      button_filter: 'Aplicar Filtro',
    },
    viewTags: {
      button_viewTags: 'Ver tags',
    },
  },
  aggregationType: {
    listening: 'publicaciones',
    sac: 'interacciones',
    'sac-listening': 'publicaciones + interacciones',
    default: 'publicaciones',
  },
};
